import { render, staticRenderFns } from "./SignInNew.vue?vue&type=template&id=1305983a&scoped=true"
import script from "./SignInNew.vue?vue&type=script&lang=js"
export * from "./SignInNew.vue?vue&type=script&lang=js"
import style0 from "./SignInNew.vue?vue&type=style&index=0&id=1305983a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305983a",
  null
  
)

export default component.exports